// Capture before async saving/advancing; never read the successor's context for a retry.
let current = null;
export function setCallTiming(customerId, callType) {
  current = customerId ? {customer_id: customerId, call_type: callType} : null;
}
export function captureCallTiming() {
  return current ? {...current, observed_at: new Date().toISOString()} : null;
}
export function callTypeFor(task, {promoMode=false, mkMode=false}={}) {
  if (task?.customer?.referral_id) return 'referral';
  const stage = task?.opportunity?.stage;
  if (stage === 'documents_requested') return 'documents_missing';
  if (stage === 'decision_phase') return 'offer_sent';
  if (stage === 'documents_received' || stage === 'offer_to_create') return 'documents_requested';
  if (stage === 'closed_won') return 'closing_followup';
  if (task?.opportunity) return 'decider_spoken';
  if (task?.followup) return 'followup';
  if (promoMode) return 'promo';
  if (mkMode || task?.customer?.source === 'personal') return 'personal';
  return 'cold_call';
}
